import { FormConfigService } from 'src/app/form-config/form-config.service';

export function GetLabelFromSettings(fieldNames: string[]): string {
  const formConfig = new FormConfigService();
  const keys = formConfig.getLabels();

  return getLabelFromSettingsRecursive(fieldNames, keys, []).join(' > ');
}

function getLabelFromSettingsRecursive(
  fieldNames: string[],
  keys: Record<string, any>,
  labels: string[]
): string[] {
  if (fieldNames.length === 0) {
    return labels;
  }

  const [currentFieldName, ...remainingFieldNames] = fieldNames;

  if (Object.prototype.hasOwnProperty.call(keys, currentFieldName)) {
    const value = keys[currentFieldName];
    if (typeof value === 'string') {
      labels.push(value);
      return getLabelFromSettingsRecursive(remainingFieldNames, keys, labels);
    } else if (value !== null && typeof value === 'object') {
      if (Object.prototype.hasOwnProperty.call(value, currentFieldName)) {
        labels.push(value[currentFieldName]);
        return getLabelFromSettingsRecursive(
          remainingFieldNames,
          value,
          labels
        );
      }
    }
  }

  return getLabelFromSettingsRecursive(remainingFieldNames, keys, labels);
}
